<template>
    <div class="w-full py-8 pt-24">
        <form @submit.prevent="newEvent" class="w-full max-w-2xl mx-auto">
            <div class="flex flex-wrap mb-3">
                <div class="w-full">
                    <label class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" for="grid-first-name">
                        Event
                    </label>
                    <input v-model="event" class="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border rounded appearance-none focus:outline-none focus:bg-white" type="text" placeholder="Name des Events / Livestreams">
                </div>
            </div>
            <div class="flex flex-wrap mb-6">
                <div class="w-full pr-3 mb-6 md:w-1/2 md:mb-0">
                <label class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" for="grid-zip">
                    Künstler / Interpret
                </label>
                <input v-model="artist" class="block w-full px-4 py-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-gray-500" id="grid-zip" type="text" placeholder="Künstler oder Interpret">
                </div>
                
                <div class="w-full pl-3 mb-6 md:w-1/2 md:mb-0">
                <label class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" for="grid-city">
                    Datum / Uhrzeit
                </label>
                <date-pick 
                    v-model="date"
                    :format="format"
                    :parseDate="parseDate"
                    :formatDate="formatDate"
                    :pickTime="true"
                    :weekdays="weekdays"
                    :months="months"
                    :selectableYearRange="{from: 2020, to: 2025}"
                    :nextMonthCaption="nextMonthCaption"
                    :prevMonthCaption="prevMonthCaption"
                    :setTimeCaption="setTimeCaption"
                    :inputAttributes="{readonly: true}"
                ></date-pick>
                </div>
            </div>
            <div class="flex flex-wrap mb-6">
                <div class="w-full">
                    <label class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase">
                        Livestream
                    </label>
                    <input v-model="stream" class="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border rounded appearance-none focus:outline-none focus:bg-white" type="text" placeholder="https://livestream.url">
                </div>
            </div>
            <div class="flex flex-wrap mb-6">
                <div class="w-full">
                    <label class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase">
                        Grafik
                    </label>
                    <input @change="onFileChange" ref="image" type="file" placeholder="Grafik hochladen" class="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border rounded appearance-none focus:outline-none focus:bg-white">
                </div>
            </div>
            <button type="submit" class="px-4 py-3 border border-gray-900 rounded hover:bg-gray-900 hover:text-white focus:outline-none">Speichern / Eintragen</button>
        </form>
    </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";

// Date/Time Picker
import DatePick from "vue-date-pick";
import "@/assets/css/datepick.scss";
import fecha from 'fecha';

export default {
    data() {
        return {
            event: "",
            format: 'dddd MMMM Do, YYYY - HH:mm',
            date: fecha.format(new Date(), 'dddd MMMM Do, YYYY - HH:mm'),
            artist: "",
            artistimage: "",
            stream: "",
            file: ""
        };
    },
    props: {
        weekdays: {
            type: Array,
            default: () => ([
                'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'
            ])
        },
        months: {
            type: Array,
            default: () => ([
                'Januar', 'Februar', 'März', 'April',
                'Mai', 'Juni', 'Juli', 'August',
                'September', 'Oktober', 'November', 'Dezember'
            ])
        },
        nextMonthCaption: {type: String, default: 'Nächster Monat'},
        prevMonthCaption: {type: String, default: 'Vorheriger Monat'},
        setTimeCaption: {type: String, default: 'Uhrzeit:'},
    },
    components: {
        DatePick
    },
    methods: {
        onFileChange() {
            const file = this.$refs.image.files[0];
            this.file = file;
        },
        parseDate(dateString, format) {
            return fecha.parse(dateString, format);
        },
        formatDate(dateObj, format) {
            return fecha.format(dateObj, format);
        },
        async newEvent() {
            try {
                // save image
                const storageRef = firebase.storage().ref('artists/' + fecha.format(new Date(), 'isoDateTime') + this.file.name);
                const uploadTask = storageRef.put(this.file);
                uploadTask.on('state_changed', (snapshot) => {
                    console.log(snapshot.state);
                }, (error) => {
                    console.log(error)
                }, () => {
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                        // add event
                        const addEvent = firebase.functions().httpsCallable('addEvent');
                        addEvent({ 
                            event: this.event,
                            date: this.date,
                            artist: this.artist,
                            artistimage: downloadURL,
                            stream: this.stream
                        })
                    });
                });
            } catch (error) {
                console.log(error);
            }            
        }
    }
}
</script>

<style lang="scss" scoped>
$vdpColor: #7485c2 !default;

@keyframes vdpSlideFromLeft {
    from { opacity: 0; transform: translate3d(-0.5em,0,0); }
    to { opacity: 1; transform: translate3d(0,0,0); }
}

@keyframes vdpSlideFromRight {
    from { opacity: 0; transform: translate3d(0.5em,0,0); }
    to { opacity: 1; transform: translate3d(0,0,0); }
}

@keyframes vdpToggleCalendar {
    from { opacity: 0; transform: scale(0.5); }
    to { opacity: 1; transform: scale(1); }
}

@keyframes vdpFadeCalendar {
    from { opacity: 0; }
    to { opacity: 1; }
}

.vdp-toggle-calendar-enter-active.vdpPositionReady {

    transform-origin: top left;
    animation: vdpToggleCalendar .2s;

}

.vdp-toggle-calendar-leave-active {

    animation: vdpToggleCalendar .15s reverse;

}

.vdp-toggle-calendar-enter-active.vdpPositionFixed {

    animation: vdpFadeCalendar .3s;

}

.vdp-toggle-calendar-leave-active.vdpPositionFixed {

    animation: vdpFadeCalendar .3s reverse;

}

.vdpComponent {

    position: relative; display: inline-block; font-size: 10px;
    color: #ffffff; width: 100%;
    /*font-family: Helvetica, Arial, sans-serif;*/

}

.vdpComponent input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    display: block;
    width: 100%;
    background-color: #edf2f7;
    color: #4a5568;
    border-width: 1px;
    border-color: #edf2f7;
    border-radius: 0.25rem;

    font-family: inherit;
    font-size: 16px;
    line-height: 1.25;

    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
}

.vdpComponent input:focus{
    outline: 0;
    background-color: #fff;
    border-color: #a0aec0;
}

.vdpComponent.vdpWithInput > input {

    padding-right: 30px;

}

.vdpClearInput {

    display: none; font-size: 1em; position: absolute; top: 0; bottom: 0; right: 0;
    width: 3em;

}

.vdpClearInput:before {

    content: '×'; width: 1.4em; height: 1.4em; line-height: 1.1em; box-sizing: border-box;
    position: absolute; left: 50%; top: 50%; margin: -0.7em 0 0 -0.7em;
    color: rgba(0,0,0,0.3); border: 1px solid rgba(0,0,0,0.15); border-radius: 50%;
    background-color: #fff;

}

.vdpClearInput:hover:before {
    box-shadow: 0 0.2em 0.5em rgba(0,0,0,0.15);
}

.vdpOuterWrap.vdpFloating {

    position: absolute; padding: 0.5em 0; z-index: 220;

}

.vdpOuterWrap.vdpPositionFixed {

    position: fixed; left: 0; top: 0; bottom: 0; right: 0;
    padding: 2em;  display: flex; justify-content: center; align-items: center;
    background-color: rgba(0,0,0,0.3);

}

.vdpFloating .vdpInnerWrap {

    max-width: 30em;

}

.vdpPositionFixed .vdpInnerWrap {

    max-width: 30em; margin: 0 auto;
    border: 0; animation: vdpToggleCalendar 0.3s;

}

.vdpFloating.vdpPositionTop { top: 100%; }
.vdpFloating.vdpPositionBottom { bottom: 100%; }
.vdpFloating.vdpPositionLeft { left: 0; }
.vdpFloating.vdpPositionRight { right: 0; }

.vdpPositionTop.vdpPositionLeft { transform-origin: top left; }
.vdpPositionTop.vdpPositionRight { transform-origin: top right; }
.vdpPositionBottom.vdpPositionLeft { transform-origin: bottom left; }
.vdpPositionBottom.vdpPositionRight { transform-origin: bottom right; }

.vdpInnerWrap {

    overflow: hidden; min-width: 28em; box-sizing: border-box; padding: 1em;
    background: #fff; box-shadow: 0 0.2em 1.5em rgba(0,0,0,0.06);
    border-radius: 0.5em;

}

.vdpHeader {

    position: relative; padding: 0 1em 2.5em; margin: -1em -1em -2.5em;
    text-align: center; background: #2d3748;

}

.vdpClearInput,
.vdpArrow,
.vdpPeriodControl > button {

     margin:0; padding: 0; border: 0; cursor: pointer; background: none;

}

.vdpArrow::-moz-focus-inner,
.vdpClearInput::-moz-focus-inner,
.vdpPeriodControl > button::-moz-focus-inner {

    padding: 0; border: 0;

}

.vdpArrow {

    font-size: 1em; width: 5em; text-indent: -999em; overflow: hidden;
    position: absolute; top: 0; bottom: 2.5em; text-align: left;

}

.vdpArrow:before {

    content: ''; width: 2.2em; height: 2.2em;
    position: absolute; left: 50%; top: 50%; margin: -1.1em 0 0 -1.1em;
    border-radius: 100%; transition: background-color 0.2s;

}

.vdpArrow:hover,
.vdpArrow:focus,
.vdpArrow:active {
    outline: 0;
}

.vdpArrow:hover:before,
.vdpArrow:focus:before {

    background-color: rgba(0,0,0,0.03);

}

.vdpArrow:active:before {

    background-color: rgba(0,0,0,0.07);

}

.vdpArrowNext:before {

    margin-left: -1.4em;

}

.vdpArrow:after {

    content: ''; position: absolute; left: 50%; top: 50%;
    margin-top: -0.5em; width: 0; height: 0;
    border: 0.5em solid transparent;

}

.vdpArrowPrev {

    left: -0.3em;

}

.vdpArrowPrev:after {

    margin-left: -0.8em;
    border-right-color: $vdpColor;

}

.vdpArrowNext {

    right: -0.6em;

}

.vdpArrowNext:after {

    margin-left: -0.5em;
    border-left-color: $vdpColor;

}

.vdpPeriodControl {

    display: inline-block; position: relative;

}

.vdpPeriodControl > button {

    font-size: 1.5em; padding: 1em 0.4em; display: inline-block;

}

.vdpPeriodControl > select {

    position: absolute; left: 0; top: 0; width: 100%; height: 100%;
    cursor: pointer; opacity: 0; font-size: 1.6em;

}

.vdpTable {

    width: 100%; table-layout: fixed; position: relative; z-index: 5;

}

.vdpNextDirection {

    animation: vdpSlideFromRight 0.5s;

}

.vdpPrevDirection {

    animation: vdpSlideFromLeft 0.5s;

}

.vdpCell, .vdpHeadCell {

    text-align: center; box-sizing: border-box;

}

.vdpCell {

    padding: 0.5em 0;

}

.vdpHeadCell {

    padding: 0.3em 0.5em 1.8em; color: #EDF2F7;

}

.vdpHeadCellContent {

    font-size: 1.3em; font-weight: normal;

}

.vdpCellContent {

    font-size: 1.4em; display: block; margin: 0 auto;
    width: 1.857em; height: 1.857em; line-height: 1.857em;
    text-align: center; border-radius: 100%;
    transition: background 0.1s, color 0.1s;

}

.vdpCell.outOfRange {

    color: #c7c7c7 !important;

}

.vdpCell.today {

    color: $vdpColor;

}

.vdpCell.selected .vdpCellContent {

    color: #fff; background: $vdpColor;

}

@media (hover: hover) {

    .vdpCell.selectable:hover .vdpCellContent {

        color: #fff; background: $vdpColor;

    }

}

.vdpCell.selectable {

    cursor: pointer;
    color: #2d3748;

}

.vdpCell.disabled {

    opacity: 0.5;

}

.vdpTimeControls {

    padding: 1.2em 2em; position: relative; margin: 1em -1em -1em;
    text-align: center;
    background: #2d3748;
    /*border-top: 1px solid rgba(0,0,0,0.15);*/

}

.vdpTimeUnit {

    display: inline-block; position: relative; vertical-align: middle;

}

.vdpTimeUnit > pre, .vdpTimeUnit > input {

    font-size: 1.7em; line-height: 1.3; padding: 0.1em 0.1em;
    word-wrap: break-word; white-space: pre-wrap;
    resize: none; margin: 0; box-sizing: border-box;
    color: #ffffff; border: 0; border-bottom: 1px solid transparent;
    text-align: center;

}

.vdpTimeUnit > pre {

    visibility: hidden; font-family: inherit;

}

.vdpTimeUnit > input {

    position: absolute; top: 0; left: 0; overflow: hidden;
    height: 100%; width: 100%; outline: none; padding: 0;
    appearance: none; border-radius: 0; background: transparent;

    -webkit-appearance: none; -moz-appearance: none; appearance: none;

}

.vdpTimeUnit > input:hover,
.vdpTimeUnit > input:focus {

    border-bottom-color: $vdpColor;

}

.vdpTimeUnit > input::-webkit-inner-spin-button,
.vdpTimeUnit > input::-webkit-outer-spin-button {
    margin: 0;
    -webkit-appearance: none;
}

.vdpTimeSeparator, .vdpTimeCaption {

    display: inline-block; vertical-align: middle; font-size: 1.3em;
    color: #ffffff;

}

.vdpTimeCaption {

    margin-right: 0.5em;

}
</style>